import Vue from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue.js?vue3';
import VueApollo from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue_apollo.js?vue3';
import { initVueApp } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/init_vue_app.js?vue3';
import apolloProvider from '/builds/gitlab/gitlab-ee/app/assets/javascripts/repository/graphql.js?vue3';
import FilePreview from '/builds/gitlab/gitlab-ee/app/assets/javascripts/repository/components/preview/index.vue?vue3';

Vue.use(VueApollo);

export const initGroupReadme = () => {
  const el = document.getElementById('js-group-readme');

  if (!el) return false;

  const { webPath, name } = el.dataset;

  return initVueApp({
    el,
    name: 'GroupFilePreviewRoot',
    apolloProvider,
    component: FilePreview,
    props: {
      blob: { webPath, name },
    },
  });
};
